export { NotFound } from 'modules/layout/containers/NotFound';
